import { css } from 'styled-components';
import token from 'styled-token';
import { StyledIcon } from '../../components/Icon/Icon.styles';
import { StyledText } from '../../components/Text/Text.styles';
import { spaceMixin } from '../spaceMixin';

/** @class NumberRating */
/** @method */
export var NumberRatingMixin = function NumberRatingMixin(props) {
  var fontType = props.fontType;
  return token({
    fontSize: "fontSizes." + fontType,
    lineHeight: "lineHeights." + fontType,
    iconFontSize: 'NumberRating.iconFontSize',
    color: 'NumberRating.color',
    textMarginRight: 'NumberRating.Text.marginRight'
  }, function (_ref) {
    var fontSize = _ref.fontSize,
      lineHeight = _ref.lineHeight,
      iconFontSize = _ref.iconFontSize,
      color = _ref.color,
      textMarginRight = _ref.textMarginRight;
    return css(["font-size:", "px;line-height:", "px;", "{font-size:", "px;color:", ";margin-bottom:-2px;vertical-align:baseline;}", "{margin-right:", ";}"], fontSize, lineHeight, StyledIcon, iconFontSize, color, StyledText, textMarginRight ? textMarginRight + "px" : spaceMixin(0.5)(props));
  })(props);
};